import { apiClient } from '@/lib/api';
/**
 * Uptime Wide Watch API client. Routes match the backend
 * UptimeMonitorController under /sslwidewatch/uptime/*.
 *
 * No orgId in any path — the backend resolves the tenant from the JWT
 * via TenantContext and Hibernate's tenantFilter enforces row isolation.
 */
export const uptimeApi = {
    list: () => apiClient.get('/sslwidewatch/uptime/monitors'),
    get: (id) => apiClient.get(`/sslwidewatch/uptime/monitors/${id}`),
    create: (body) => apiClient.post('/sslwidewatch/uptime/monitors', body),
    update: (id, body) => apiClient.patch(`/sslwidewatch/uptime/monitors/${id}`, body),
    remove: (id) => apiClient.delete(`/sslwidewatch/uptime/monitors/${id}`),
    /** Force an immediate probe — bypasses the interval gate. */
    recheck: (id) => apiClient.post(`/sslwidewatch/uptime/monitors/${id}/check`, {}),
    summary: () => apiClient.get('/sslwidewatch/uptime/summary'),
    // Group membership management (managed from the group editor).
    groupMembers: (groupId) => apiClient.get(`/sslwidewatch/uptime/groups/${groupId}/members`),
    addGroupMember: (groupId, monitorId) => apiClient.post(`/sslwidewatch/uptime/groups/${groupId}/members/${monitorId}`, {}),
    /** Bulk-add: pass several monitor ids in one request. */
    addGroupMembers: (groupId, monitorIds) => apiClient.post(`/sslwidewatch/uptime/groups/${groupId}/members`, { monitorIds }),
    removeGroupMember: (groupId, monitorId) => apiClient.delete(`/sslwidewatch/uptime/groups/${groupId}/members/${monitorId}`),
};
export const alertTemplatesApi = {
    list: () => apiClient.get('/sslwidewatch/alerts/templates'),
    upsert: (body) => apiClient.post('/sslwidewatch/alerts/templates', body),
    /** Reset to platform default — soft-deletes the override row. */
    remove: (id) => apiClient.delete(`/sslwidewatch/alerts/templates/${id}`),
    /** Render unsaved template against sample data. Returns rendered subject+body. */
    preview: (body) => apiClient.post('/sslwidewatch/alerts/templates/preview', body),
};
/**
 * Alert groups live under /sslwidewatch/alerts/groups (in the alerting
 * controller, not uptime) — they're cross-product but uptime is the
 * first consumer.
 */
export const alertGroupsApi = {
    list: () => apiClient.get('/sslwidewatch/alerts/groups'),
    get: (id) => apiClient.get(`/sslwidewatch/alerts/groups/${id}`),
    create: (body) => apiClient.post('/sslwidewatch/alerts/groups', body),
    update: (id, body) => apiClient.patch(`/sslwidewatch/alerts/groups/${id}`, body),
    remove: (id) => apiClient.delete(`/sslwidewatch/alerts/groups/${id}`),
    // Recipients (sub-resource).
    listRecipients: (groupId) => apiClient.get(`/sslwidewatch/alerts/groups/${groupId}/recipients`),
    addRecipient: (groupId, body) => apiClient.post(`/sslwidewatch/alerts/groups/${groupId}/recipients`, body),
    updateRecipient: (groupId, recipientId, body) => apiClient.patch(`/sslwidewatch/alerts/groups/${groupId}/recipients/${recipientId}`, body),
    removeRecipient: (groupId, recipientId) => apiClient.delete(`/sslwidewatch/alerts/groups/${groupId}/recipients/${recipientId}`),
};
